import { render, staticRenderFns } from "./PoolDetail.vue?vue&type=template&id=db54a1ba"
import script from "./PoolDetail.vue?vue&type=script&lang=ts"
export * from "./PoolDetail.vue?vue&type=script&lang=ts"
import style0 from "./PoolDetail.vue?vue&type=style&index=0&id=db54a1ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports